import http from '../api/http.js';
import store from '@/store/index';
import router from '@/router/index';

import config from "../../config/index.js";

import jwt_decode from "jwt-decode";

import Vue from 'vue';
import { Loading, Toast, Dialog } from 'vant';
Vue.use(Loading, Toast, Dialog);
function collect(item, sourceId, sourceType) {
  common.sys.pass().then(() => {
    // var sourceId = item.id || item.sourceId || item.bookId;
    common.loading.open();
    http.api.SubmitCollect({ sourceId: sourceId, sourceType: sourceType }).then((res) => {
      common.loading.close();
      if (res.code != 1) {
        return common.message.error(res.info);
      }
      item.collect = !item.collect;
      item.collectTotal = res.data;
    });
  });
}
let common = {
  env: {
    version: 'dev', // dev, test, prod
  },
  verify: {
    url(url) {
      if (url.indexOf("http:") == 0 || url.indexOf("https:") == 0) {
        return true;
      }
      // url= 协议://(ftp的登录信息)[IP|域名](:端口号)(/或?请求参数)
      var strRegex =
        '^((https|http|ftp)://)?' + // (https或http或ftp):// 可有可无
        "(([\\w_!~*'()\\.&=+$%-]+: )?[\\w_!~*'()\\.&=+$%-]+@)?" + // ftp的user@  可有可无
        '(([0-9]{1,3}\\.){3}[0-9]{1,3}' + // IP形式的URL- 3位数字.3位数字.3位数字.3位数字
        '|' + // 允许IP和DOMAIN（域名）
        '(localhost)|' + // 匹配localhost
        "([\\w_!~*'()-]+\\.)*" + // 域名- 至少一个[英文或数字_!~*\'()-]加上.
        '\\w+\\.' + // 一级域名 -英文或数字  加上.
        '[a-zA-Z]{1,6})' + // 顶级域名- 1-6位英文
        '(:[0-9]{1,5})?' + // 端口- :80 ,1-5位数字
        '((/?)|' + // url无参数结尾 - 斜杆或这没有
        "(/[\\w_!~*'()\\.;?:@&=+$,%#-]+)+/?)$"; // 请求参数结尾- 英文或数字和[]内的各种字符
      var re = new RegExp(strRegex, 'i'); // i不区分大小写
      // 将url做uri转码后再匹配，解除请求参数中的中文和空字符影响
      if (re.test(encodeURI(url))) {
        return true;
      }
      return false;
    },
    ios() {
      const userAgent = navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(userAgent) || ['iPhone', 'iPad', 'iPod'].includes(navigator.platform);
    },
    tel: (tel) => {
      if (!tel) {
        common.message.error("请输入手机号");
        return false;
      }
      // 验证手机号
      const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
      if (!reg.test(tel)) {
        common.message.error("请输入正确的电话号码");
        return false;
      }
      return true;
    }
  },
  richText(html) {
    if (!html) {
      return "";
    }
    return html.replaceAll('\n', '<br>').replaceAll(' ', '&nbsp;&nbsp;')
  },
  getImg(src, url) {
    if (common.verify.url(src)) {
      return src;
    }
    if (src.indexOf("http://") > -1 || src.indexOf("https://") > -1) {
      return src;
    }
    if (url) {
      if (url[url.length - 1] == "/") {
        url = url.substr(0, url.length - 1);
      }
      return url + src;
    }
    return src;
  },
  removeHtml(html) {
    if (!html) {
      return '';
    }
    return html.replace(/<[^>]+>|\s*/g, '');
  },
  getParams() {
    var url = location.href;
    if (url.indexOf("?") == -1) {
      return {};
    }
    var str = location.href.split("?")[1];
    var arr = str.split("&");
    var params = {};
    for (var i = 0; i < arr.length; i++) {
      var result = arr[i].split("=");
      if (result.length != 2) {
        continue;
      }
      params[result[0]] = result[1];
    }
    return params;
  },
  showFooter() {
    if (localStorage.getItem('hideFooter') && localStorage.getItem('hideFooter') == 'true') {
      return false;
    }
    return true;
  },
  hideFooter() {
    localStorage.setItem('hideFooter', true);
  },
  local(src) {
    if (common.verify.url(src)) {
      return src;
    }
    if (src.indexOf("http://") > -1 || src.indexOf("https://") > -1) {
      return src;
    }
    var url = http.host;
    if (url[url.length - 1] == "/") {
      url = url.substr(0, url.length - 1);
    }
    return url + src;
  },
  cloud(src) {
    if (!src) {
      return '';
    }
    if (src.indexOf('/') == 0) {
      src = src.substring(1);
    }
    return 'https://web-resources.obs.cn-east-3.myhuaweicloud.com/xjdread/CoreReadPic/' + src;
  },
  loading: {
    open: (title) => {
      Toast.loading({
        message: title,
        duration: 0,      // 持续展示 toast
        forbidClick: true,// 锁屏
      });
    },
    close: () => {
      Toast.clear();
    },
  },
  message: {
    alert: (title, message) => {
      Dialog.alert({ title: title, message: message }).then(() => { });
    },
    success: (msg, duration) => {
      if (duration == undefined) {
        duration = 2000;
      }
      Toast.setDefaultOptions({ duration: duration });
      Toast(msg);
      // Toast.success(msg);
    },
    error: (msg, duration) => {
      if (duration == undefined) {
        duration = 2000;
      }
      Toast.setDefaultOptions({ duration: duration });
      Toast(msg);
      // Toast.fail(msg);
    },
    confirm: (message, title) => new Promise((resolve, reject) => {
      var options = {};
      if (title) {
        options.title = title;
      }
      if (message) {
        options.message = message;
      }
      Dialog.confirm(options).then(() => {
        resolve();
      }).catch(() => {
        reject();
      });
    }),
  },
  to: {
    path: (path) => {
      if (!path || path == window.location.pathname) {
        return;
      }
      if (common.verify.url(path)) {
        location.href = path;
        return;
      }
      router.push(path);
    },
    home: (refresh) => {
      if (refresh) {
        location.replace(config.path.router ? config.path.router : "/");
        return;
      }
      common.to.path("/");
    },
    back: () => {
      router.go(-1);
    },
    agency: (timeout) => {
      var path = "/selectAgency?redirect=" + encodeURIComponent(encodeURIComponent(location.href));
      if (timeout) {
        setTimeout(() => { common.to.path(path); }, timeout);
        return;
      }
      common.to.path(path);
    }
  },
  wx: {
    platform: () => {
      return navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1;
    },
    decode: () => new Promise((resolve, reject) => {
      var code = common.getParams().code;
      if (code) {
        var params = {
          host: location.href,
          token: common.token.get(),
          inviteId: common.getParams().inviteId,
          schoolId: common.getParams().schoolId,
          logout: common.sys.logout.get(),
          code: code
        };
        http.api.decode(params).then((res) => {
          if (res.code != 1) {
            return common.message.alert(res.info);
          }
          resolve(res);
        });
      } else {
        var appId = "wx1d131ed1765faddb";
        var redirect = encodeURIComponent(location.href.replace(':8080', ''));
        // 正式跳转
        location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appId + "&redirect_uri=" + redirect + "&response_type=code&scope=snsapi_userinfo#wechat_redirect";
        // 测试跳转
        // location.href = "http://localhost:8080?sid=" + sid + "&code=yqq";
      }
    }),
  },
  token: {
    get: () => {
      var token = localStorage.getItem('site.token');
      return token && token.length >= 128 ? token : null;
    },
    set: (data) => {
      localStorage.setItem('site.token', data);
    },
    remove: () => {
      localStorage.removeItem('site.token');
    },
    jwt: (token) => {
      token = token ? token : common.token.get();
      if (token) {
        return jwt_decode(token);
      }
      return undefined;
    },
    authorize: "Authorization",
    headers: (type) => {
      var token = common.token.get();
      if (type && type == 'json') {
        return {
          'Content-Type': 'application/json',
          'Authorization': token
        }
      }
      return { Authorization: token };
    },
    lock: {
      get: () => {
        return localStorage.getItem('lock.token');
      },
      set: () => {
        localStorage.setItem('lock.token', true);
      },
      remove: () => {
        localStorage.removeItem('lock.token');
      },
    }
  },
  sys: {
    pass: (overt) => new Promise((resolve, reject) => {
      var member = common.member.get();
      if (!member) {
        return common.quick.login.open();
      }
      if (!overt && member.overt) {
        return common.quick.login.open();
      }
      resolve();
    }),
    login: {
      get: () => { return localStorage.getItem('status.login') || false; },
      set: () => { localStorage.setItem('status.login', true); },
      remove: () => { localStorage.removeItem('status.login'); },
    },
    logout: {
      get: () => { return localStorage.getItem('status.logout') || false; },
      set: () => { localStorage.setItem('status.logout', true); },
      remove: () => { localStorage.removeItem('status.logout'); },
    }
  },
  member: {
    overt: () => {
      var member = common.member.get();
      if (!member || member.overt) {
        return true;
      }
      return false;
    },
    login: (data) => new Promise((resolve, reject) => {
      common.sys.login.set();
      if (data.member && !data.member.overt) {
        common.sys.logout.remove();
      }
      common.member.reset(data).then(() => {
        resolve();
      });
    }),
    logout: () => new Promise((resolve, reject) => {
      common.sys.logout.set();
      common.member.clear();
      resolve();
    }),
    reset: (data) => new Promise((resolve, reject) => {
      if (!data || !data.org) {
        return common.message.error("未找到机构");
      }
      // 删除机构缓存，存粹是为了看缓存的时候，token，机构，用户排列一起
      common.org.remove();
      common.org.set(data.org);

      common.token.remove();
      if (data.token) {
        common.token.set(data.token);
      }
      if (data.invite) {
        common.invite.set(data.invite);
      }
      if (data.member && !data.member.auth) {
        common.member.agency.set();
      }
      resolve();
    }),
    clear: () => {
      common.token.remove();
    },
    get: () => {
      var item = common.token.get();
      return item ? jwt_decode(item) : undefined;
    },
    id: () => {
      var member = common.member.get();
      return member ? member.userId : "";
    },
    oauth: {
      get: () => {
        var item = localStorage.getItem('wx.member');
        return item ? JSON.parse(item) : undefined;
      },
      set: (val) => { localStorage.setItem('wx.member', JSON.stringify(val)); },
    },
    agency: {
      get: () => { return localStorage.getItem('status.agency') || false; },
      set: () => { localStorage.setItem('status.agency', true); },
      remove: () => { localStorage.removeItem('status.agency'); },
    },
  },
  quick: {
    login: {
      open() {
        store.commit('setLogin', true);
      },
      close() {
        store.commit('setLogin', false);
      }
    },
    agency: {
      open(id) {
        if (!id) {
          return;
        }
        store.commit('setAgency', id);
      },
      close() {
        store.commit('setAgency', null);
      }
    },
  },
  sms: {
    second: {
      get: () => { return localStorage.getItem('sms.second') || null; },
      set: (val) => { localStorage.setItem('sms.second', val); },
      remove: () => { localStorage.removeItem('sms.second'); },
    },
    send: (tel) => new Promise((resolve, reject) => {
      if (!common.verify.tel(tel)) {
        return;
      }
      http.api.SendSms({ tel: tel }).then((res) => {
        if (res.code != 1) {
          return common.message.error(res.info);
        }
        common.message.success("短信发送成功");
        resolve();
      });
    }),
  },
  org: {
    key: 'site.org',
    get: () => {
      var item = localStorage.getItem(common.org.key);
      return item ? JSON.parse(item) : undefined;
    },
    set: (data) => {
      localStorage.setItem(common.org.key, JSON.stringify(data));
    },
    remove: () => {
      localStorage.removeItem(common.org.key);
    },
    id: () => {
      var org = common.org.get();
      return org ? org.id : "";
    },
    code: () => {
      var org = common.org.get();
      return org ? org.code : "";
    },
    match: (open, confirm) => new Promise((resolve, reject) => {
      common.loading.open();
      http.api.matchOrg().then((res) => {
        common.loading.close();
        if (res.code != 1) {
          return common.message.error(res.info);
        }
        if (res.data) {
          return common.quick.agency.open(res.data);
        }
        if (open) {
          common.to.agency();
        }
        if (confirm) {
          common.message.confirm('认证机构').then(() => {
            common.to.agency();
          });
        }
      });
    })
  },
  invite: {
    key: 'site.invite',
    get: () => {
      var item = localStorage.getItem(common.invite.key);
      return item ? JSON.parse(item) : undefined;
    },
    set: (data) => {
      localStorage.setItem(common.invite.key, JSON.stringify(data));
    }
  },
  read: {
    error: (ex) => {
      common.message.error(ex.replace("error auth empty:", "").replace("error auth expire:", ""));
      if (ex.indexOf("error auth empty") > -1) {
        return common.org.match(null, true);
      }
      if (ex.indexOf("error auth expire") > -1) {
        common.message.confirm('认证机构').then(() => {
          common.to.agency();
        });
        return;
      }
    },
    open: (id, page) => new Promise((resolve, reject) => {
      common.sys.pass(true).then(() => {
        http.api.GetReadUrl({ id: id, page: page, terminal: '2' }).then((res) => {
          if (res.code != 1) {
            return common.read.error(res.info);
          }
          var url = res.data.url;
          if (!url) {
            return common.book.open(id);
          }
          if (common.member.id() == 'MEMBER_YI') {
            alert(url);
          }
          if (common.verify.ios()) {
            location.href = url;
          } else {
            window.open(url, '_blank');
          }
        });
      });
    }),
    verify: (id) => new Promise((resolve, reject) => {
      common.sys.pass(true).then(() => {
        http.api.VerifyBookAuth({ id: id }).then((res) => {
          if (res.code != 1) {
            return common.read.error(res.info);
          }
          resolve();
        });
      });
    }),
    get: () => {
      var item = localStorage.getItem('site.read');
      return item ? JSON.parse(item) : null;
    },
    set: (data) => {
      localStorage.setItem('site.read', JSON.stringify(data));
    },
    remove: () => {
      localStorage.removeItem('site.read');
    }
  },
  book: {
    open: (id, attr) => {
      if (!attr) {
        http.api.GetBookInfo({ id: id }).then((res) => {
          if (res.code != 1) {
            return common.message.error(res.info);
          }
          common.book.open(id, res.data.attr);
        });
        return;
      }
      if (attr == "2") {
        common.to.path("/book/detail/pod/" + id);
      } else {
        common.to.path("/book/detail/txt/" + id);
      }
    },
    buy: (bookId, purchaseId) => new Promise((resolve, reject) => {
      common.sys.pass(true).then(() => {
        common.message.confirm('暂无全文，是否荐购?').then(() => {
          http.api.AddPurchaseRecord({ bookId: bookId, purchaseId: purchaseId, confirm: true });
          http.api.GetHuiCaiUrl({ id: bookId }).then((res) => {
            if (res.code != 1) {
              return common.message.error(res.info);
            }
            var url = res.data;
            if (common.verify.ios()) {
              location.href = url;
            } else {
              window.open(url, '_blank');
            }
          });
        }).catch(() => {
          http.api.AddPurchaseRecord({ bookId: bookId, purchaseId: purchaseId, confirm: false });
        });
      });
    }),
    borrow: (item) => {
      common.sys.pass().then(() => {
        http.api.VerifyBookAuth({ id: item.id }).then((res) => {
          if (res.code != 1) {
            return common.read.error(res.info);
          }
          var params = { bookid: item.id, status: item.borrow ? 1 : 0 };
          http.api.ReadyBook(params).then((res) => {
            if (res.code != 1) {
              common.message.error(res.data)
              return;
            }

            item.borrow = !item.borrow;

            common.message.success(item.borrow ? "归还成功!" : "借阅成功!");
          });
        });
      });
    },
    collect: (item, sourceId, sourceType) => {
      if (!sourceId && !sourceType) {
        sourceId = item.id;
        sourceType = item.attr;
      }
      if (item.bookId) {
        sourceId = item.bookId;
        sourceType = 1;
      }
      collect(item, sourceId, sourceType);
    },
    category: (params) => {
      var url = '/category';
      if (params) {
        url += params;
      }
      common.to.path(url);
    },
    search: (params) => {
      var url = '/book/search';
      if (params) {
        url += params;
      }
      common.to.path(url);
    },
    share: (id) => new Promise(() => {
      common.sys.pass().then(() => {
        common.to.path('/book/poster/index/' + id);
      });
    }),
    cover: (src) => {
      if (!src) {
        return common.cloud('/empty/book.jpg');
      }
      return src;
    },
    last: {
      duration: {
        key: 'podcast.last.duration',
        get: () => {
          var list = localStorage.getItem(common.book.last.duration.key) || '[]';
          return JSON.parse(list);
        },
        set: (bookId, podcastId, duration) => {
          var list = common.book.last.duration.get();
          list = list.filter(o => o.bookId != bookId);
          list.push({ bookId: bookId, podcastId: podcastId, duration: duration });
          localStorage.setItem(common.book.last.duration.key, JSON.stringify(list));
        },
        val: (bookId, podcastId) => {
          var list = common.book.last.duration.get().filter(o => o.bookId == bookId && o.podcastId == podcastId);
          if (list.length == 0) {
            return 0;
          }
          return list[0].duration;
        },
      },
    },
  },
  work: {
    search: (tagId) => {
      var url = '/Work';
      if (tagId) {
        url += '?tagId=' + tagId;
      }
      common.to.path(url);
    },
    player: (id, tag) => {
      common.to.path('/work/player?id=' + id + '&tag=' + tag);
    }
  },
  sheet: {
    open: (id) => {
      http.api.GetSheetInfo({ id: id, schoolId: common.org.code() }).then((res) => {
        if (res.code != 1) {
          return common.message.error(res.info);
        }
        if (res.data.url && res.data.bookTotal == 0) {
          return common.to.path(res.data.url);
        }
        common.to.path('/sheetDetail?id=' + id);
      });
    },
    collect: (item) => {
      collect(item, item.id, 5);
    },
  },
  activity: {
    open: (id) => {
      common.loading.open();
      http.api.GetActivityDetail({ id: id }).then((res) => {
        common.loading.close();
        if (res.data.model.enroll && res.data.model.status == 2) {
          window.location.href = res.data.url;
        } else {
          common.to.path('/activity/detail?id=' + id);
        }
      });
    }
  },
  date: {
    now: () => {
      let today = new Date();
      // 获取年、月、日
      let year = today.getFullYear(); // 获取年份
      let month = today.getMonth() + 1; // 获取月份（注意：getMonth() 返回的月份是从0开始的，所以要加1）
      let day = today.getDate(); // 获取日期
      let formattedDate = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
      return formattedDate;
    },
    toHour: (duration) => {
      var hour = common.date.padZero(parseInt(duration / 3600));
      var minute = common.date.padZero(parseInt((duration % 3600) / 60));
      var second = common.date.padZero(parseInt(duration % 60));
      return hour + ":" + minute + ":" + second;
    },
    toMinute: (duration) => {
      var minute = common.date.padZero(parseInt((duration % 3600) / 60));
      var second = common.date.padZero(parseInt(duration % 60));
      return minute + ":" + second;
    },
    padZero: (number) => {
      return number < 10 ? "0" + number : number;
    }
  },
  timeout: {
    lock: false,
    run: (second) => new Promise((resolve, reject) => {
      console.log(second, common.timeout.pass);
      if (common.timeout.lock) {
        return;
      }
      common.timeout.pass = false;
      setTimeout(() => { common.timeout.pass = true; }, second * 1000);
      resolve();
    }),
  },
  form: {
    get: (list) => {
      var info = {};
      list.forEach(item => {
        if (info[item.name] === undefined) {
          info[item.name] = null;
        }
      });
      return info;
    }
  }
};
export default common;



// WEBPACK FOOTER //
// ./src/units/common.js